/**
 * Solo lobby quiz cards: images from `public/assets/preview/{key}.webp` or `.png`.
 * Same key rules as WITC question images (see {@link sanitizeImageAssetFileKey}).
 */

import { sanitizeImageAssetFileKey } from './quizQuestionImageSrc';

const ROOT = '/assets/preview';

export function quizPreviewImageUrlsFromKey(key: string | null | undefined): { webp: string; png: string } | null {
  const k = sanitizeImageAssetFileKey(key);
  if (!k) return null;
  const pub = process.env.PUBLIC_URL || '';
  const base = `${pub}${ROOT}/${k}`;
  return { webp: `${base}.webp`, png: `${base}.png` };
}

/** Legacy quizzes may still store a full https URL in `imageUrl`. */
export function isQuizImageUrlLegacyHttp(value: string | null | undefined): boolean {
  if (!value?.trim()) return false;
  const v = value.trim().toLowerCase();
  return v.startsWith('http://') || v.startsWith('https://');
}
